module.exports = __webpack_public_path__ + "assets/img/introduction.a2512ca1.png";